import React, { useId, useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { AH_ACCENT, AH_BORDER, AH_MUTED, AH_SUBTLE, AH_TEXT, AH_TRACK, AH_WHITE } from "../../AuditHub/theme";

const sectionLabelSx = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: AH_MUTED,
};

const sequenceSx = {
  width: 24,
  height: 24,
  borderRadius: "6px",
  backgroundColor: AH_TRACK,
  color: AH_SUBTLE,
  fontSize: 11,
  fontWeight: 700,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const ControlRemediations = ({ steps }) => {
  const [open, setOpen] = useState(false);
  const panelId = useId();
  const ordered = useMemo(() => {
    if (!Array.isArray(steps)) return [];
    return steps.map((step) => (typeof step === "string" ? step.trim() : "")).filter(Boolean);
  }, [steps]);

  if (!ordered.length) return null;

  return (
    <Box
      sx={{
        mb: 2.5,
        border: `1px solid ${AH_BORDER}`,
        borderRadius: "10px",
        backgroundColor: AH_WHITE,
        overflow: "hidden",
      }}
    >
      <Box
        component="button"
        type="button"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((value) => !value)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          px: 1.5,
          py: 1.25,
          m: 0,
          border: "none",
          backgroundColor: "#edf4fb",
          cursor: "pointer",
          textAlign: "left",
          "&:hover": { backgroundColor: "#e3eef8" },
          "&:focus-visible": { outline: `2px solid ${AH_ACCENT}`, outlineOffset: -2 },
        }}
      >
        <Typography component="span" sx={sectionLabelSx}>Remediations</Typography>
        <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.25, fontSize: 12, fontWeight: 600, color: "#1976d2" }}>
          {open ? "Hide" : "Show"}
          <ExpandMoreRoundedIcon
            sx={{ fontSize: 18, transition: "transform 0.2s ease", transform: open ? "rotate(180deg)" : "none" }}
          />
        </Box>
      </Box>
      {open ? (
        <Box id={panelId} component="ol" sx={{ listStyle: "none", m: 0, px: 1.5, pt: 1.5, pb: 1.25, borderTop: `1px solid ${AH_BORDER}`, display: "flex", flexDirection: "column", gap: 1.25 }}>
          {ordered.map((step, index) => (
            <Box component="li" key={index} sx={{ display: "flex", alignItems: "flex-start", gap: 1.25, minWidth: 0 }}>
              <Box sx={sequenceSx} aria-hidden="true">
                {index + 1}
              </Box>
              <Typography sx={{ flex: 1, minWidth: 0, fontSize: 13, fontWeight: 600, color: AH_TEXT, lineHeight: 1.5, overflowWrap: "anywhere" }}>
                {step}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : null}
    </Box>
  );
};

export default ControlRemediations;
